import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { db } from '../../App';
import DocumentDetailsView from '../../components/DocumentDetailsView';
import { LEXElementType } from '../../global/types';

const LexDocumentDetails = () => {
    const { documentSlug } = useParams();
    const [documentItem, setDocumentItem] = useState<LEXElementType | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        const loadDocument = async () => {
            try {
                if(!documentSlug) throw new Error('not-found');
                const snapshot = await getDocs(query(collection(db, 'lex'), where('slug', '==', documentSlug), limit(1)));
                const result = snapshot.docs[0];
                if(!result) throw new Error('not-found');
                if(active) setDocumentItem({ ...result.data(), id: Number(result.id) } as LEXElementType);
            } catch {
                if(active) setDocumentItem(null);
            } finally {
                if(active) setLoading(false);
            }
        };
        loadDocument();
        return () => { active = false; };
    }, [documentSlug]);

    if(loading) return <div className="mx-auto my-[10vh] rounded-xl bg-white p-8 text-gray-500">Chargement...</div>;
    if(!documentItem) return (
        <div className="mx-auto my-[10vh] max-w-xl rounded-xl bg-white p-8 text-center">
            <h1 className="mb-3 text-2xl font-medium">Document LEX introuvable</h1>
            <Link className="text-primary underline" to="/lex">Retour à FLAG LEX</Link>
        </div>
    );

    return <DocumentDetailsView
        title={documentItem.title}
        downloadUrl={documentItem.documentUrl}
        backTo="/lex"
        backLabel="Retour à FLAG LEX"
    />;
};

export default LexDocumentDetails;
